import declare from	"dojo/_base/declare";
import crews from "csi/access/crews";
import Action from "csi/def/Action";
import def from	"csi/def";
import xml from	"csi/xml";

const PromoteToShapeAction =  declare(Action, {

	validate: function(/*Context*/ctx) {
		// summary: don't show action is user does not have proper access
		var	style = ctx.getNode();
		return style &&
				xml.nodeHasRight(style, xml.RIGHT_WRITE) &&
				def.canNavigateToType("Shape") &&
				crews.isInGlobalRoles(["Shape Administrator"]) &&
				this.inherited(arguments);
	},
});

export = PromoteToShapeAction;